import { render } from "./ResetTokenExpiredView.vue?vue&type=template&id=018de63f"
import script from "./ResetTokenExpiredView.vue?vue&type=script&lang=js"
export * from "./ResetTokenExpiredView.vue?vue&type=script&lang=js"

import "./ResetTokenExpiredView.vue?vue&type=style&index=0&id=018de63f&lang=scss"

import exportComponent from "/codebuild/output/src886087124/src/dt-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__